import { BaseQueryDTO } from "./basequery-dto";

export class QueryProposalDTO extends BaseQueryDTO {
    PartInfoId: number;
    TransportModeId: number;
    PackageTypeId: number;
    SourceTypeId: number;
    EffectiveFrom: Date | string;
    EffectiveTo: Date | string;
    POUoM: string;
}
